import React, { useState } from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import { PasswordInput } from '../input/password-input';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';

export type CustomPasswordInputProps = {
    label: string;
    name: string;
    required?: boolean;
};

export const CustomPasswordInput: React.FC<CustomPasswordInputProps> = ({
    label,
    name,
    required = false,
}) => {
    const { t } = useTranslation();
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState('');

    const isFloating = focused || value;

    return (
        <Form.Item
            name={name}
            rules={[{ required, message: t('required_field') }]}
            className={styles.formItem}
        >
            <div
                className={cn(styles.wrapper, {
                    [styles.focused]: isFloating,
                })}
            >
                <label
                    className={cn(styles.label, {
                        [styles.labelFloating]: isFloating,
                    })}
                >
                    {label}
                </label>
                <PasswordInput
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onFocus={() => setFocused(true)}
                    onBlur={e => setFocused(!!e.target.value)}
                    className={styles.input}
                />
                <div className={styles.underline} />
            </div>
        </Form.Item>
    );
};
